export default {
    name: 'MobileEditor',
    path: '/mobileeditor',
    meta: {
      title: 'Bop Cat Meme Generator - Mobile'
    }
  };
  